export const BASE_URL = 'https://mate-uber-eats-api.herokuapp.com/api/v1';
